import { Helmet } from 'react-helmet-async';
import { useState, useEffect, createContext, useContext } from 'react';
import { getSiteSettings } from '@/lib/api';

const SeoContext = createContext(null);

export function SeoProvider({ children }) {
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    getSiteSettings().then(res => setSeoData(res.data)).catch(() => {});
  }, []);

  return <SeoContext.Provider value={seoData}>{children}</SeoContext.Provider>;
}

export default function SEO({ title, description }) {
  const seoData = useContext(SeoContext);

  const siteName = 'SLE Online';
  const defaultTitle = seoData?.seo_title || `Shubha Lakshmi Enterprises | Premium Hospitality Supplies - ${siteName}`;
  const fullTitle = title ? `${title} | ${siteName}` : defaultTitle;
  const defaultDesc = seoData?.seo_description || 'Premium hospitality supplies, eco-friendly packaging, guest amenities, and cleaning solutions. Trusted by leading hotels across India.';
  const desc = description || defaultDesc;
  const keywords = seoData?.seo_keywords || '';
  const ogTitle = seoData?.og_title || fullTitle;
  const ogDesc = seoData?.og_description || desc;
  const ogImage = seoData?.og_image_url || '';
  const canonical = seoData?.canonical_url || '';

  return (
    <Helmet title={fullTitle}>
      <meta name="description" content={desc} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={title ? fullTitle : ogTitle} />
      <meta property="og:description" content={description || ogDesc} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:title" content={title ? fullTitle : ogTitle} />
      <meta name="twitter:description" content={description || ogDesc} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
}
